import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            width: '100%',
            maxW: remCalc(1400),
            position: 'relative',
            m: '0 auto',
            py: {base: 'xsmall.base', md: 'small.base', lg: 'small.md', xl: 0},
        },
        textblock: {
            position: {base: 'inherit', xl: 'absolute'},
            top: 0,
            left: 0,
            width: '100%',
            height: {base: 'auto', xl: '100%'},
            direction: 'column',
            justifyContent: 'center',
            textAlign: {base: 'center', xl: 'left'},
            alignItems: {base: 'center', xl: 'baseline'},
            mx: 'auto',
            pl: {base: 0, xl: remCalc(120)},
        },
    },
    variants: {
        pageheader: {
            container: {
                px: 0,
                py: 0,
            },
        },
    },
}
